var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "markets-wrapper",
      class: {
        "live-single-event": _vm.diplayOnPage == "live-single-event",
        coupon: _vm.diplayOnPage == "coupon"
      }
    },
    [
      _vm.markets
        ? _c(
            "div",
            {
              staticClass: "markets",
              class: [
                { multiple: _vm.markets.length > 1 && _vm.maxNumOfMarkets > 1 },
                {
                  single: _vm.markets.length === 1 || _vm.maxNumOfMarkets === 1
                },
                { empty: _vm.markets.length === 0 || _vm.maxNumOfMarkets === 0 }
              ]
            },
            [
              _vm.isBig3Coupon && _vm.diplayOnPage == "live-single-event"
                ? _c("big3-markets-header", {
                    attrs: {
                      coupontitle:
                        _vm.markets &&
                        _vm.markets[0] &&
                        _vm.markets[0].gameperiodname,
                      markets: [
                        _vm.pointsMarket,
                        _vm.moneyMarket,
                        _vm.totalMarket
                      ],
                      diplayOnPage: _vm.diplayOnPage,
                      isLiveEventPage: _vm.isLiveEventPage,
                      idfosporttype1: this.event.idfosporttype,
                      "is-big3-coupon": true,
                      marketNameForHeaderForEventMarketGroupWithOneMarket:
                        _vm.marketNameForHeaderForEventMarketGroupWithOneMarket,
                      "max-no-of-markets": _vm.markets && _vm.markets.length,
                      isoutright: false,
                      isPointsMarketAvailableForBB:
                        _vm.isPointsMarketAvailableForBB,
                      isMoneyMarketAvailableForBB:
                        _vm.isMoneyMarketAvailableForBB,
                      isTotalMarketAvailableForBB:
                        _vm.isTotalMarketAvailableForBB,
                      isNonBig3MarketAvailableForBB:
                        _vm.isNonBig3MarketAvailableForBB
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isDebug
                ? [
                    _vm._v("\n        MARKETS "),
                    _c("br"),
                    _vm._v(
                      "\n        isBig3Coupon " +
                        _vm._s(_vm.isBig3Coupon) +
                        "\n      "
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isBig3Coupon
                ? _c("div", { staticClass: "big3" }, [
                    _vm.currentPath == "SportsEvent"
                      ? _c(
                          "div",
                          {
                            class: [
                              "market name",
                              {
                                "has-pitchers":
                                  _vm.event.awaypitchername ||
                                  _vm.event.awaypitchername
                              },
                              { "team-logos": _vm.teamLogoVisibility }
                            ]
                          },
                          [
                            _c("div", { staticClass: "layout" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "AWAY"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "AWAY"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.awayTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnameaway ||
                                              _vm.event.participantname_away
                                          )
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.participantname_away ||
                                              _vm.event
                                                .participantshortname_away
                                          )
                                        )
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isPitcherVisible
                                ? _c("span", { staticClass: "smaller" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("span", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.awaypitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "layout" }, [
                              _vm.luListcode4ParticipantMake(
                                _vm.event,
                                "HOME"
                              ) !== ""
                                ? _c("span", { staticClass: "listcode" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.luListcode4ParticipantMake(
                                          _vm.event,
                                          "HOME"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "event-info-name-wrapper" },
                                [
                                  _vm.teamLogoVisibility
                                    ? _c("span", {
                                        staticClass: "team-logo",
                                        style: _vm.homeTeamLogoStyle
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.teamLogoVisibility &&
                                  _vm.mobileBigAndBelow
                                    ? _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.shortnamehome ||
                                              _vm.event.participantname_home
                                          )
                                        )
                                      ])
                                    : _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.participantname_home ||
                                              _vm.event
                                                .participantshortname_home
                                          )
                                        )
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isPitcherVisible
                                ? _c("span", { staticClass: "smaller" }, [
                                    _c("span", { staticClass: "cell" }),
                                    _c("span", { staticClass: "cell" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("lowercase")(
                                            _vm.event.homepitchername
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "markets",
                        class: {
                          "big3-column-order": _vm.big3ColumOrderEnabled
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "market points",
                            class: [_vm.big3PointsSpreadOrder]
                          },
                          [
                            _vm.pointsMarket
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: {
                                      idfomarket: _vm.pointsMarket.idfomarket.toString(),
                                      isfrompush: (
                                        _vm.pointsMarket.V !== undefined
                                      ).toString()
                                    }
                                  },
                                  [
                                    _vm.isDebug
                                      ? _c("span", [
                                          _vm._v("\n                MARKET "),
                                          _c("br"),
                                          _vm._v(
                                            "\n                idfomarket " +
                                              _vm._s(
                                                _vm.pointsMarket.idfomarket
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                isfrompush " +
                                              _vm._s(
                                                (
                                                  _vm.pointsMarket.V !==
                                                  undefined
                                                ).toString()
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _vm.pointsMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "A"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.pointsMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "A"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.pointsMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "A"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.pointsMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.pointsMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "A"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.pointsMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.pointsMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.pointsMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "A"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _vm.pointsMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "H"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.pointsMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "H"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.pointsMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "H"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.pointsMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.pointsMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "H"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.pointsMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.pointsMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.pointsMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "H"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: { idfomarket: "null" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "market money",
                            class: [_vm.big3MoneyLineOrder]
                          },
                          [
                            _vm.moneyMarket
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: {
                                      idfomarket: _vm.moneyMarket.idfomarket.toString(),
                                      isfrompush: (
                                        _vm.moneyMarket.V !== undefined
                                      ).toString()
                                    }
                                  },
                                  [
                                    _vm.isDebug
                                      ? _c("span", [
                                          _vm._v("\n                MARKET "),
                                          _c("br"),
                                          _vm._v(
                                            "\n                idfomarket " +
                                              _vm._s(_vm.moneyMarket.idfomarket)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                isfrompush " +
                                              _vm._s(
                                                (
                                                  _vm.moneyMarket.V !==
                                                  undefined
                                                ).toString()
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _vm.moneyMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "A"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.moneyMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "A"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.moneyMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "A"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.moneyMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.moneyMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "A"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.moneyMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.moneyMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.moneyMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "A"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _vm.moneyMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "H"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.moneyMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "H"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.moneyMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "H"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.moneyMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.moneyMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "H"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.moneyMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.moneyMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.moneyMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "H"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: { idfomarket: "null" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "market total",
                            class: [_vm.big3TotalPointsOrder]
                          },
                          [
                            _vm.totalMarket
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: {
                                      idfomarket: _vm.totalMarket.idfomarket.toString(),
                                      isfrompush: (
                                        _vm.totalMarket.V !== undefined
                                      ).toString()
                                    }
                                  },
                                  [
                                    _vm.isDebug
                                      ? _c("span", [
                                          _vm._v("\n                MARKET "),
                                          _c("br"),
                                          _vm._v(
                                            "\n                idfomarket " +
                                              _vm._s(_vm.totalMarket.idfomarket)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                isfrompush " +
                                              _vm._s(
                                                (
                                                  _vm.totalMarket.V !==
                                                  undefined
                                                ).toString()
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _vm.totalMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "O"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.totalMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "O"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.totalMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "O"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.totalMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.totalMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "O"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.totalMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.totalMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.totalMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "O"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _vm.totalMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "U"
                                            }
                                          )[0]
                                            ? _c(
                                                "span",
                                                {
                                                  class: [
                                                    "selection",
                                                    "flex",
                                                    {
                                                      active:
                                                        _vm.betslipSelections[
                                                          _vm.totalMarket.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "U"
                                                              )
                                                            }
                                                          )[0].idfoselection
                                                        ]
                                                    }
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.toggleSelection(
                                                        _vm.totalMarket.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.hadvalue ===
                                                              "U"
                                                            )
                                                          }
                                                        )[0],
                                                        _vm.totalMarket
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: _vm.totalMarket.selections.filter(
                                                        function(sel) {
                                                          return (
                                                            sel.hadvalue === "U"
                                                          )
                                                        }
                                                      )[0],
                                                      istradable:
                                                        _vm.totalMarket
                                                          .istradable &&
                                                        !_vm.ksIsMarketSuspended(
                                                          _vm.totalMarket,
                                                          _vm.event
                                                        ),
                                                      showselectionname: false,
                                                      pricechangehighlight:
                                                        _vm.pricechangehighlight
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.totalMarket.selections.filter(
                                            function(sel) {
                                              return sel.hadvalue === "U"
                                            }
                                          )[0]
                                            ? _c("span", [
                                                _c("div", {
                                                  staticClass:
                                                    "missingMarketsHolder"
                                                })
                                              ])
                                            : _vm._e()
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "selections layout",
                                    attrs: { idfomarket: "null" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "", wrap: "" } },
                                      [
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _c(
                                            "span",
                                            { class: ["selection", "flex"] },
                                            [
                                              _c("selection", {
                                                attrs: {
                                                  selection: {},
                                                  istradable: true,
                                                  showselectionname: false
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filteredMarkets, function(market, index) {
                return !_vm.isBig3Coupon
                  ? _c(
                      "div",
                      {
                        key: market.idfomarket,
                        class: [
                          "market",
                          {
                            suspended:
                              !market.istradable ||
                              _vm.ksIsMarketSuspended(market, _vm.event),
                            "three-and-more-selections":
                              _vm.selectionCount4UI(market) >= 3 ||
                              market.isoutright,
                            three:
                              _vm.selectionCount4UI(market) === 3 &&
                              !market.isoutright,
                            "two-selections":
                              _vm.selectionCount4UI(market) === 2 &&
                              !market.isoutright
                          }
                        ],
                        attrs: {
                          idfomarket: market.idfomarket,
                          isfrompush: (market.V !== undefined).toString()
                        }
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          {
                            staticClass: "market-collapse",
                            attrs: { value: index === 0 ? 0 : 1 }
                          },
                          [
                            _c(
                              "v-expansion-panel-content",
                              {
                                attrs: {
                                  id: ["market-" + market.idfomarket],
                                  "expand-icon": ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("div", { staticClass: "market-name" }, [
                                      _c(
                                        "h4",
                                        { staticClass: "market-name-title" },
                                        [_vm._v(_vm._s(market.name))]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isDebug
                                  ? _c("span", [
                                      _vm._v("\n              MARKET "),
                                      _c("br"),
                                      _vm._v(
                                        "\n              idfomarket " +
                                          _vm._s(market.idfomarket)
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n              isfrompush " +
                                          _vm._s(
                                            (market.V !== undefined).toString()
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n              isHadMarket(market) " +
                                          _vm._s(_vm.isHadMarket(market)) +
                                          "\n              Number of active selections " +
                                          _vm._s(
                                            market.selections.filter(function(
                                              sel
                                            ) {
                                              return (
                                                sel.idfoselectionsuspensiontype !==
                                                "N/O"
                                              )
                                            }).length
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !isNaN(parseInt(market.currentmatchhandicap))
                                  ? _c("div", { staticClass: "handicap-value" })
                                  : _vm._e(),
                                _vm._v(" "),
                                market.selections.length <= 3 &&
                                !market.isoutright
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "parent",
                                        class: {
                                          "selections-in-columns":
                                            _vm.diplayOnPage ===
                                              "live-single-event" ||
                                            [
                                              "GOLF",
                                              "MOTORSPORT",
                                              "NASCAR"
                                            ].indexOf(market.idfosporttype) > -1
                                        }
                                      },
                                      [
                                        _vm.currentPath == "SportsEvent"
                                          ? _c(
                                              "div",
                                              { staticClass: "market name" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "layout" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.event
                                                          .participantname_home
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "layout" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.event
                                                          .participantname_away
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "selections-container"
                                          },
                                          [
                                            market &&
                                            market.selections &&
                                            _vm.isHadMarket(market) &&
                                            (_vm.diplayOnPage ===
                                              "live-single-event" ||
                                              market.idfosporttype !== "MMA")
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: [
                                                      "selections",
                                                      {
                                                        layout:
                                                          market.idfohadtype ===
                                                          "HAD"
                                                      },
                                                      {
                                                        hasdraw:
                                                          market.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.hadvalue ===
                                                                "D"
                                                              )
                                                            }
                                                          ).length > 0
                                                      },
                                                      {
                                                        handicap:
                                                          market.name
                                                            .toLowerCase()
                                                            .indexOf(
                                                              "handicap"
                                                            ) > -1
                                                      }
                                                    ]
                                                  },
                                                  _vm._l(
                                                    ["H", "D", "A", "O", "U"],
                                                    function(hadvalue, index) {
                                                      return _vm.drawSelectionForHadvalue(
                                                        market,
                                                        hadvalue
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "selection flex",
                                                              class: hadvalue
                                                            },
                                                            _vm._l(
                                                              _vm.getSelectionsByHAD(
                                                                market.selections,
                                                                hadvalue
                                                              ),
                                                              function(
                                                                selection
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      selection.idfoselection,
                                                                    class: [
                                                                      "selection-column",
                                                                      hadvalue,
                                                                      {
                                                                        active:
                                                                          _vm
                                                                            .betslipSelections[
                                                                            selection
                                                                              .idfoselection
                                                                          ]
                                                                      }
                                                                    ],
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.toggleSelection(
                                                                          selection,
                                                                          market
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm.diplayOnPage ===
                                                                      "live-single-event" ||
                                                                    [
                                                                      "GOLF",
                                                                      "MOTORSPORT",
                                                                      "NASCAR"
                                                                    ].indexOf(
                                                                      market.idfosporttype
                                                                    ) > -1
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "selection-name"
                                                                          },
                                                                          [
                                                                            selection.listcode
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "listcode"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        selection.listcode
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                selection.name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "selection",
                                                                      {
                                                                        attrs: {
                                                                          selection: selection,
                                                                          istradable:
                                                                            market.istradable &&
                                                                            !_vm.ksIsMarketSuspended(
                                                                              market,
                                                                              _vm.event
                                                                            ),
                                                                          showselectionname:
                                                                            !_vm.iscoupondisplay &&
                                                                            market.isoutright,
                                                                          ishad: true,
                                                                          pricechangehighlight:
                                                                            _vm.pricechangehighlight
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            market &&
                                            market.selections &&
                                            (!_vm.isHadMarket(market) ||
                                              (_vm.diplayOnPage !==
                                                "live-single-event" &&
                                                market.idfosporttype === "MMA"))
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "selections layout all non-had"
                                                  },
                                                  _vm._l(
                                                    _vm.sortedSelections({
                                                      market: market,
                                                      selections:
                                                        market.selections
                                                    }),
                                                    function(selection) {
                                                      return selection.idfoselectionsuspensiontype !==
                                                        "N/O"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              key:
                                                                selection.idfoselection,
                                                              class: [
                                                                "selection",
                                                                "flex",
                                                                {
                                                                  active:
                                                                    _vm
                                                                      .betslipSelections[
                                                                      selection
                                                                        .idfoselection
                                                                    ]
                                                                }
                                                              ],
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.toggleSelection(
                                                                    selection,
                                                                    market
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "selection-column"
                                                                },
                                                                [
                                                                  _vm.diplayOnPage ===
                                                                    "live-single-event" ||
                                                                  [
                                                                    "MMA",
                                                                    "BASKETBALL",
                                                                    "GOLF",
                                                                    "MOTORSPORT",
                                                                    "NASCAR"
                                                                  ].indexOf(
                                                                    market.idfosporttype
                                                                  ) > -1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "selection-name"
                                                                        },
                                                                        [
                                                                          selection.listcode
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "listcode"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      selection.listcode
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              selection.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "selection",
                                                                    {
                                                                      attrs: {
                                                                        selection: selection,
                                                                        istradable:
                                                                          market.istradable &&
                                                                          !_vm.ksIsMarketSuspended(
                                                                            market,
                                                                            _vm.event
                                                                          ),
                                                                        showselectionname:
                                                                          !_vm.iscoupondisplay &&
                                                                          market.isoutright,
                                                                        ishad: false,
                                                                        pricechangehighlight:
                                                                          _vm.pricechangehighlight
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (market.selections.length > 3 ||
                                  market.isoutright) &&
                                _vm.diplayOnPage === "live-single-event"
                                  ? _c(
                                      "div",
                                      { staticClass: "selections-container" },
                                      [
                                        market.webnote
                                          ? _c(
                                              "div",
                                              { staticClass: "marketwebnote" },
                                              [_vm._v(_vm._s(market.webnote))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.mobileBigAndBelow
                                          ? _c("v-flex", [
                                              _c(
                                                "div",
                                                {
                                                  class: [
                                                    "flex-more3-container",
                                                    _vm.noOfColumns(market)
                                                  ]
                                                },
                                                [
                                                  market.selections.filter(
                                                    function(sel) {
                                                      return (
                                                        sel.internalorder < 1000
                                                      )
                                                    }
                                                  ).length > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "flex-item"
                                                        },
                                                        _vm._l(
                                                          _vm.expandedMarkets[
                                                            market.idfomarket
                                                          ]
                                                            ? _vm.sortedSelections(
                                                                {
                                                                  market: market,
                                                                  selections: market.selections.filter(
                                                                    function(
                                                                      sel
                                                                    ) {
                                                                      return (
                                                                        sel.internalorder <
                                                                          1000 &&
                                                                        sel.idfoselectionsuspensiontype !==
                                                                          "N/O"
                                                                      )
                                                                    }
                                                                  )
                                                                }
                                                              )
                                                            : _vm
                                                                .sortedSelections(
                                                                  {
                                                                    market: market,
                                                                    selections: market.selections.filter(
                                                                      function(
                                                                        sel
                                                                      ) {
                                                                        return (
                                                                          sel.internalorder <
                                                                            1000 &&
                                                                          sel.idfoselectionsuspensiontype !==
                                                                            "N/O"
                                                                        )
                                                                      }
                                                                    )
                                                                  }
                                                                )
                                                                .slice(0, 3),
                                                          function(selection) {
                                                            return selection.internalorder <
                                                              1000 &&
                                                              selection.idfoselectionsuspensiontype !==
                                                                "N/O"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      selection.idfoselection,
                                                                    class: [
                                                                      "selections",
                                                                      {
                                                                        active:
                                                                          _vm
                                                                            .betslipSelections[
                                                                            selection
                                                                              .idfoselection
                                                                          ]
                                                                      },
                                                                      selection.hadvalue
                                                                    ],
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.toggleSelection(
                                                                          selection,
                                                                          market
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "selectionname"
                                                                      },
                                                                      [
                                                                        selection.listcode
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "listcode"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    selection.listcode
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            selection.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    selection.internalorder <
                                                                    1000
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            class: [
                                                                              "selection",
                                                                              "layout",
                                                                              {
                                                                                hasdraw:
                                                                                  market.selections.filter(
                                                                                    function(
                                                                                      sel
                                                                                    ) {
                                                                                      return (
                                                                                        sel.hadvalue ===
                                                                                        "D"
                                                                                      )
                                                                                    }
                                                                                  )
                                                                                    .length >
                                                                                  0
                                                                              }
                                                                            ]
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "selection",
                                                                              {
                                                                                attrs: {
                                                                                  selection: selection,
                                                                                  istradable:
                                                                                    market.istradable &&
                                                                                    !_vm.ksIsMarketSuspended(
                                                                                      market,
                                                                                      _vm.event
                                                                                    ),
                                                                                  showselectionname: false,
                                                                                  ishad: false,
                                                                                  pricechangehighlight:
                                                                                    _vm.pricechangehighlight
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  market.selections.filter(
                                                    function(sel) {
                                                      return (
                                                        sel.internalorder >=
                                                          1000 &&
                                                        sel.internalorder < 2000
                                                      )
                                                    }
                                                  ).length > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "flex-item"
                                                        },
                                                        _vm._l(
                                                          _vm.expandedMarkets[
                                                            market.idfomarket
                                                          ]
                                                            ? _vm.sortedSelections(
                                                                {
                                                                  market: market,
                                                                  selections: market.selections.filter(
                                                                    function(
                                                                      sel
                                                                    ) {
                                                                      return (
                                                                        sel.internalorder >=
                                                                          1000 &&
                                                                        sel.internalorder <
                                                                          2000 &&
                                                                        sel.idfoselectionsuspensiontype !==
                                                                          "N/O"
                                                                      )
                                                                    }
                                                                  )
                                                                }
                                                              )
                                                            : _vm
                                                                .sortedSelections(
                                                                  {
                                                                    market: market,
                                                                    selections: market.selections.filter(
                                                                      function(
                                                                        sel
                                                                      ) {
                                                                        return (
                                                                          sel.internalorder >=
                                                                            1000 &&
                                                                          sel.internalorder <
                                                                            2000 &&
                                                                          sel.idfoselectionsuspensiontype !==
                                                                            "N/O"
                                                                        )
                                                                      }
                                                                    )
                                                                  }
                                                                )
                                                                .slice(0, 3),
                                                          function(selection) {
                                                            return selection.internalorder >=
                                                              1000 &&
                                                              selection.internalorder <
                                                                2000 &&
                                                              selection.idfoselectionsuspensiontype !==
                                                                "N/O"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      selection.idfoselection,
                                                                    class: [
                                                                      "selections",
                                                                      {
                                                                        active:
                                                                          _vm
                                                                            .betslipSelections[
                                                                            selection
                                                                              .idfoselection
                                                                          ]
                                                                      },
                                                                      selection.hadvalue
                                                                    ],
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.toggleSelection(
                                                                          selection,
                                                                          market
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "selectionname"
                                                                      },
                                                                      [
                                                                        selection.listcode
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "listcode"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    selection.listcode
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            selection.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    selection.internalorder >=
                                                                      1000 &&
                                                                    selection.internalorder <
                                                                      2000
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            class: [
                                                                              "selection",
                                                                              "layout",
                                                                              {
                                                                                hasdraw:
                                                                                  market.selections.filter(
                                                                                    function(
                                                                                      sel
                                                                                    ) {
                                                                                      return (
                                                                                        sel.hadvalue ===
                                                                                        "D"
                                                                                      )
                                                                                    }
                                                                                  )
                                                                                    .length >
                                                                                  0
                                                                              }
                                                                            ]
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "selection",
                                                                              {
                                                                                attrs: {
                                                                                  selection: selection,
                                                                                  istradable:
                                                                                    market.istradable &&
                                                                                    !_vm.ksIsMarketSuspended(
                                                                                      market,
                                                                                      _vm.event
                                                                                    ),
                                                                                  showselectionname: false,
                                                                                  ishad: false,
                                                                                  pricechangehighlight:
                                                                                    _vm.pricechangehighlight
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  market.selections.filter(
                                                    function(sel) {
                                                      return (
                                                        sel.internalorder >=
                                                        2000
                                                      )
                                                    }
                                                  ).length > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "flex-item"
                                                        },
                                                        _vm._l(
                                                          _vm.expandedMarkets[
                                                            market.idfomarket
                                                          ]
                                                            ? _vm.sortedSelections(
                                                                {
                                                                  market: market,
                                                                  selections: market.selections.filter(
                                                                    function(
                                                                      sel
                                                                    ) {
                                                                      return (
                                                                        sel.internalorder >=
                                                                          2000 &&
                                                                        sel.idfoselectionsuspensiontype !==
                                                                          "N/O"
                                                                      )
                                                                    }
                                                                  )
                                                                }
                                                              )
                                                            : _vm
                                                                .sortedSelections(
                                                                  {
                                                                    market: market,
                                                                    selections: market.selections.filter(
                                                                      function(
                                                                        sel
                                                                      ) {
                                                                        return (
                                                                          sel.internalorder >=
                                                                            2000 &&
                                                                          sel.idfoselectionsuspensiontype !==
                                                                            "N/O"
                                                                        )
                                                                      }
                                                                    )
                                                                  }
                                                                )
                                                                .slice(0, 3),
                                                          function(selection) {
                                                            return selection.internalorder >=
                                                              2000 &&
                                                              selection.idfoselectionsuspensiontype !==
                                                                "N/O"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      selection.idfoselection,
                                                                    class: [
                                                                      "selections",
                                                                      {
                                                                        active:
                                                                          _vm
                                                                            .betslipSelections[
                                                                            selection
                                                                              .idfoselection
                                                                          ]
                                                                      },
                                                                      selection.hadvalue
                                                                    ],
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.toggleSelection(
                                                                          selection,
                                                                          market
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "selectionname"
                                                                      },
                                                                      [
                                                                        selection.listcode
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "listcode"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    selection.listcode
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            selection.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    selection.internalorder >=
                                                                    2000
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            class: [
                                                                              "selection",
                                                                              "layout",
                                                                              {
                                                                                hasdraw:
                                                                                  market.selections.filter(
                                                                                    function(
                                                                                      sel
                                                                                    ) {
                                                                                      return (
                                                                                        sel.hadvalue ===
                                                                                        "D"
                                                                                      )
                                                                                    }
                                                                                  )
                                                                                    .length >
                                                                                  0
                                                                              }
                                                                            ]
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "selection",
                                                                              {
                                                                                attrs: {
                                                                                  selection: selection,
                                                                                  istradable:
                                                                                    market.istradable &&
                                                                                    !_vm.ksIsMarketSuspended(
                                                                                      market,
                                                                                      _vm.event
                                                                                    ),
                                                                                  showselectionname: false,
                                                                                  ishad: false,
                                                                                  pricechangehighlight:
                                                                                    _vm.pricechangehighlight
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.diplayOnPage !==
                                                "live-single-event" &&
                                              market.selections.filter(function(
                                                sel
                                              ) {
                                                return (
                                                  sel.idfoselectionsuspensiontype !==
                                                  "N/O"
                                                )
                                              }).length > 9
                                                ? _c(
                                                    "div",
                                                    { staticClass: "time" },
                                                    [
                                                      _vm.isDateToday(
                                                        _vm.event.tsstart
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BettingOffer.Today"
                                                                )
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm.event
                                                                      .tsstart,
                                                                    _vm
                                                                      .dateFormats
                                                                      .longTime
                                                                  )
                                                                )
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isDateTomorrow(
                                                        _vm.event.tsstart
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BettingOffer.Tomorrow"
                                                                )
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm.event
                                                                      .tsstart,
                                                                    _vm
                                                                      .dateFormats
                                                                      .longTime
                                                                  )
                                                                )
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isDateToday(
                                                        _vm.event.tsstart
                                                      ) &&
                                                      !_vm.isDateTomorrow(
                                                        _vm.event.tsstart
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "moment"
                                                                )(
                                                                  _vm.event
                                                                    .tsstart,
                                                                  _vm
                                                                    .dateFormats
                                                                    .longDateTimeMG
                                                                )
                                                              ) + " "
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.marketCondition(market)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "show-more-btn"
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            ripple: false,
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.toggleExpandMarket(
                                                                market.idfomarket
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: !_vm
                                                                    .expandedMarkets[
                                                                    market
                                                                      .idfomarket
                                                                  ],
                                                                  expression:
                                                                    "!expandedMarkets[market.idfomarket]"
                                                                }
                                                              ]
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BettingOffer.SeeMore"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm
                                                                      .expandedMarkets[
                                                                      market
                                                                        .idfomarket
                                                                    ],
                                                                  expression:
                                                                    "expandedMarkets[market.idfomarket]"
                                                                }
                                                              ]
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BettingOffer.SeeLess"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mobileBigAndBelow
                                          ? _c(
                                              "v-flex",
                                              [
                                                _vm._l(
                                                  _vm.expandedMarkets[
                                                    market.idfomarket
                                                  ]
                                                    ? _vm.sortedSelections({
                                                        market: market,
                                                        selections: market.selections.filter(
                                                          function(sel) {
                                                            return (
                                                              sel.idfoselectionsuspensiontype !==
                                                              "N/O"
                                                            )
                                                          }
                                                        )
                                                      })
                                                    : _vm
                                                        .sortedSelections({
                                                          market: market,
                                                          selections: market.selections.filter(
                                                            function(sel) {
                                                              return (
                                                                sel.idfoselectionsuspensiontype !==
                                                                "N/O"
                                                              )
                                                            }
                                                          )
                                                        })
                                                        .slice(0, 9),
                                                  function(selection) {
                                                    return selection.idfoselectionsuspensiontype !==
                                                      "N/O"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            key:
                                                              selection.idfoselection,
                                                            class: [
                                                              "selections-mobile mobile",
                                                              {
                                                                active:
                                                                  _vm
                                                                    .betslipSelections[
                                                                    selection
                                                                      .idfoselection
                                                                  ]
                                                              }
                                                            ],
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.toggleSelection(
                                                                  selection,
                                                                  market
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("selection", {
                                                              attrs: {
                                                                selection: selection,
                                                                istradable:
                                                                  market.istradable &&
                                                                  !_vm.ksIsMarketSuspended(
                                                                    market,
                                                                    _vm.event
                                                                  ),
                                                                showselectionname: true,
                                                                ishad: false,
                                                                isoutright:
                                                                  market.isoutright,
                                                                pricechangehighlight:
                                                                  _vm.pricechangehighlight
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _vm.diplayOnPage !==
                                                  "live-single-event" &&
                                                market.selections.length > 9
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "time" },
                                                      [
                                                        _vm.isDateToday(
                                                          _vm.event.tsstart
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BettingOffer.Today"
                                                                  )
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm.event
                                                                        .tsstart,
                                                                      _vm
                                                                        .dateFormats
                                                                        .longTime
                                                                    )
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isDateTomorrow(
                                                          _vm.event.tsstart
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BettingOffer.Tomorrow"
                                                                  )
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm.event
                                                                        .tsstart,
                                                                      _vm
                                                                        .dateFormats
                                                                        .longTime
                                                                    )
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.isDateToday(
                                                          _vm.event.tsstart
                                                        ) &&
                                                        !_vm.isDateTomorrow(
                                                          _vm.event.tsstart
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm.event
                                                                      .tsstart,
                                                                    _vm
                                                                      .dateFormats
                                                                      .longDateTimeMG
                                                                  )
                                                                ) + " "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                market.selections.filter(
                                                  function(sel) {
                                                    return (
                                                      sel.idfoselectionsuspensiontype !==
                                                      "N/O"
                                                    )
                                                  }
                                                ).length > 9
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-more-btn"
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              ripple: false,
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.toggleExpandMarket(
                                                                  market.idfomarket
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value: !_vm
                                                                      .expandedMarkets[
                                                                      market
                                                                        .idfomarket
                                                                    ],
                                                                    expression:
                                                                      "!expandedMarkets[market.idfomarket]"
                                                                  }
                                                                ]
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BettingOffer.SeeMore"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm
                                                                        .expandedMarkets[
                                                                        market
                                                                          .idfomarket
                                                                      ],
                                                                    expression:
                                                                      "expandedMarkets[market.idfomarket]"
                                                                  }
                                                                ]
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BettingOffer.SeeLess"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (market.selections.length > 3 ||
                                  market.isoutright) &&
                                _vm.diplayOnPage !== "live-single-event"
                                  ? _c(
                                      "div",
                                      { staticClass: "selections-container" },
                                      [
                                        market.webnote
                                          ? _c(
                                              "div",
                                              { staticClass: "marketwebnote" },
                                              [_vm._v(_vm._s(market.webnote))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          _vm._l(
                                            _vm.expandedMarkets[
                                              market.idfomarket
                                            ]
                                              ? _vm.sortedSelections({
                                                  market: market,
                                                  selections: market.selections.filter(
                                                    function(sel) {
                                                      return (
                                                        sel.idfoselectionsuspensiontype !==
                                                        "N/O"
                                                      )
                                                    }
                                                  )
                                                })
                                              : _vm
                                                  .sortedSelections({
                                                    market: market,
                                                    selections: market.selections.filter(
                                                      function(sel) {
                                                        return (
                                                          sel.idfoselectionsuspensiontype !==
                                                          "N/O"
                                                        )
                                                      }
                                                    )
                                                  })
                                                  .slice(0, 9),
                                            function(selection) {
                                              return selection.idfoselectionsuspensiontype !==
                                                "N/O"
                                                ? _c(
                                                    "span",
                                                    {
                                                      key:
                                                        selection.idfoselection,
                                                      class: [
                                                        "selections-mobile",
                                                        {
                                                          active:
                                                            _vm
                                                              .betslipSelections[
                                                              selection
                                                                .idfoselection
                                                            ]
                                                        },
                                                        {
                                                          mobile:
                                                            _vm.mobileBigAndBelow
                                                        }
                                                      ],
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.toggleSelection(
                                                            selection,
                                                            market
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("selection", {
                                                        attrs: {
                                                          selection: selection,
                                                          istradable:
                                                            market.istradable &&
                                                            !_vm.ksIsMarketSuspended(
                                                              market,
                                                              _vm.event
                                                            ),
                                                          showselectionname: true,
                                                          ishad: false,
                                                          isoutright:
                                                            market.isoutright,
                                                          pricechangehighlight:
                                                            _vm.pricechangehighlight
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _vm.isLiveEventMarket &&
                                        _vm.event.markets &&
                                        _vm.event.markets[0] &&
                                        _vm.event.markets[0].selections &&
                                        _vm.event.markets[0].selections.length >
                                          9
                                          ? _c("live-coupon-event-footer", {
                                              class: [
                                                {
                                                  "in-play-live-coupon-footer":
                                                    _vm.isLiveEventMarket
                                                }
                                              ],
                                              attrs: {
                                                event: _vm.liveEvents.find(
                                                  function(ev) {
                                                    return (
                                                      ev.idfoevent ===
                                                      _vm.event.idfoevent
                                                    )
                                                  }
                                                ),
                                                couponname:
                                                  _vm.couponname ||
                                                  "Live coupon"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isLiveEventMarket &&
                                        market.selections.filter(function(sel) {
                                          return (
                                            sel.idfoselectionsuspensiontype !==
                                            "N/O"
                                          )
                                        }).length > 9
                                          ? _c("div", { staticClass: "time" }, [
                                              _vm.isDateToday(_vm.event.tsstart)
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BettingOffer.Today"
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            _vm.event.tsstart,
                                                            _vm.dateFormats
                                                              .longTime
                                                          )
                                                        )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isDateTomorrow(
                                                _vm.event.tsstart
                                              )
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BettingOffer.Tomorrow"
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            _vm.event.tsstart,
                                                            _vm.dateFormats
                                                              .longTime
                                                          )
                                                        )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isDateToday(
                                                _vm.event.tsstart
                                              ) &&
                                              !_vm.isDateTomorrow(
                                                _vm.event.tsstart
                                              )
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          _vm.event.tsstart,
                                                          _vm.dateFormats
                                                            .longDateTimeMG
                                                        )
                                                      ) + " "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        market.selections.filter(function(sel) {
                                          return (
                                            sel.idfoselectionsuspensiontype !==
                                            "N/O"
                                          )
                                        }).length > 9
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "show-more-btn",
                                                class: [
                                                  {
                                                    "in-play-live-coupon":
                                                      _vm.isLiveEventMarket
                                                  }
                                                ]
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      ripple: false
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.toggleExpandMarket(
                                                          market.idfomarket
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: !_vm
                                                              .expandedMarkets[
                                                              market.idfomarket
                                                            ],
                                                            expression:
                                                              "!expandedMarkets[market.idfomarket]"
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BettingOffer.SeeMore"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm
                                                                .expandedMarkets[
                                                                market
                                                                  .idfomarket
                                                              ],
                                                            expression:
                                                              "expandedMarkets[market.idfomarket]"
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BettingOffer.SeeLess"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e07da95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e07da95","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/markets.vue
// module id = null
// module chunks = 